import React from 'react'
import { Message } from '../type'
import { Image } from './styles'

interface Props {
  type: 'sent' | 'received'
  message: Message
}

const ImageMessage: React.FC<Props> = ({ type, message }) => {
  return (
    <a
      href={message.upload?.url}
      target="_blank"
      rel="noopener noreferrer"
      download={message.upload?.name}
    >
      <Image
        type={type}
        src={message.upload?.small}
      />
    </a>
  )
}

export default ImageMessage
